export const FileOwnerType = {
    'client': 'client',
    'manager': 'manager',
}
